import React, { useEffect, useState } from 'react';
import maintenance from '../assets/maintenance.jpg';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../style.css';
import qrCode from '../assets/qr.png';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { bucketDb } from './helpers/Config.js';

function Registration() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [events, setEvents] = useState(null);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const savedUser = JSON.parse(localStorage.getItem('user'));
    const [user, setUser] = useState('');
    const [formData, setFormData] = useState({
        userId: savedUser ? savedUser._id : "",
        eventId: id,
        name: '',
        email: '',
        address: '',
        city: '',
        country: '',
        paymentMethod: '',
        cardNumber: '',
        igmMembership: '',
        idNumber: '',
        phoneNumber: '',
        companyAddress: '',
        picName: '',
        picEmail: '',
        picPhoneNum: '',
        consent: false,
        paymentProof: null,
        paymentProofName: '',
        transferRefNo: ''
    });
    const [noEventsMessage, setNoEventsMessage] = useState({});
    const [errors, setErrors] = useState({}); // State for validation errors
    const [isLoading, setIsLoading] = useState(false);
    const [existingEvent, setExistingEvent] = useState([]);
    const [existingUser, setExistingUser] = useState([]);

    useEffect(() => {
        setLoading(true);

        const fetchEvents = async () => {
            try {
                const response = await axios.get(`https://geoid-rest.vercel.app/events/${id}`);
                setEvents(response.data);
                setExistingEvent(response.data.participant)
            } catch (error) {
                console.error('Error fetching media:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchEvents();
    }, [id]);

    useEffect(() => {
        setLoading(true);

        const fetchEvents = async () => {
            try {
                const response = await axios.get(`https://geoid-rest.vercel.app/users/${savedUser.user._id}`);
                setUser(response.data);
                setExistingUser(response.data.events)
            } catch (error) {
                console.error('Error fetching media:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchEvents();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validateForm = () => {
        const newErrors = {};
        // Validation based on the current page
        if (currentPage === 0) {
            if (!formData.name) newErrors.name = "Name is required";
            if (!formData.address) newErrors.address = "Mailing Address is required";
            if (!formData.email) newErrors.email = "Email is required";
            if (!formData.phoneNumber) newErrors.phoneNumber = "Phone Number is required";
            if (!formData.igmMembership) newErrors.igmMembership = "IGM Membership is required";
            if (formData.igmMembership === 'yes' && !formData.idNumber) newErrors.idNumber = "ID Number is required";
            if (!formData.paymentMethod) newErrors.paymentMethod = "Payment Method is required";
        } else if (currentPage === 1 && formData.paymentMethod !== 'Personal' && events.paymentMethod === 'onUs') {
            if (!formData.companyAddress) newErrors.companyAddress = "Company Address is required";
            if (!formData.picName) newErrors.picName = "Contact Person (PIC) is required";
            if (!formData.picEmail) newErrors.picEmail = "PIC Email is required";
            if (!formData.picPhoneNum) newErrors.picPhoneNum = "PIC Phone Number is required";
        } else if (currentPage === 1 && formData.paymentMethod === 'Personal' && events.paymentMethod === 'onUs') {
            if (!formData.paymentProof) newErrors.paymentProof = "Proof of payment is required";
            if (!formData.transferRefNo) newErrors.transferRefNo = "Reference Number is required";
        } else if (currentPage === 2) {
            if (!formData.consent) newErrors.consent = "Consent is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const nextPage = () => {
        if (validateForm()) {
            if (events.paymentMethod === 'offUs' && currentPage === 0) {
                setCurrentPage(2);
            }
            setCurrentPage((prev) => Math.min(prev + 1, 2));
        }
    };

    const prevPage = () => {
        if (events.paymentMethod === 'offUs' && currentPage === 2) {
            setCurrentPage(0);
        } else {
            setCurrentPage((prev) => Math.max(prev - 1, 0));
        }
    };

    const handleClose = (e) => {
        navigate(`/events/${events._id}`);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            setIsLoading(true)
            const fileRef = ref(bucketDb, `eventRegistration/${formData.paymentProofName}`);

            uploadBytes(fileRef, formData.paymentProof)
            .then(uploadResult => {
              return getDownloadURL(uploadResult.ref);
            }).then(url => {
                const participantData = {
                    userId: formData.userId,
                    eventId: formData.eventId,
                    name: formData.name,
                    email: formData.email,
                    address: formData.address,
                    city: formData.city,
                    country: formData.country,
                    paymentMethod: formData.paymentMethod,
                    cardNumber: formData.cardNumber,
                    igmMembership: formData.igmMembership,
                    idNumber: formData.idNumber,
                    phoneNumber: formData.phoneNumber,
                    companyAddress: formData.companyAddress,
                    picName: formData.picName,
                    picEmail: formData.picEmail,
                    picPhoneNum: formData.picPhoneNum,
                    consent: formData.consent,
                    paymentProof: url,
                    paymentProofName: formData.paymentProofName,
                    transferRefNo: formData.transferRefNo
                };

                const requestBody1 = {
                    events: [...existingUser, participantData]
                };

                axios.put(`https://geoid-rest.vercel.app/users/${savedUser.user._id}`, requestBody1);

                const requestBody2 = {
                    participant: [...existingEvent, participantData]
                };

                return axios.put(`https://geoid-rest.vercel.app/events/${formData.eventId}`, requestBody2);
              })
              .then(response => {

                setFormData({
                    userId: savedUser.user._id,
                    eventId: id,
                    name: '',
                    email: '',
                    address: '',
                    city: '',
                    country: '',
                    paymentMethod: '',
                    cardNumber: '',
                    igmMembership: '',
                    idNumber: '',
                    phoneNumber: '',
                    companyAddress: '',
                    picName: '',
                    picEmail: '',
                    picPhoneNum: '',
                    consent: false,
                    paymentProof: null,
                    paymentProofName: '',
                    transferRefNo: ''
                });
              })
              .catch(error => {
                console.error('Error:', error);
                toast.error('Error Occured');
                setIsLoading(false)
              }).finally(() => {
                toast.success('Successfully registered!');
                navigate(`/events/${id}`);
                setIsLoading(false)
              })
        }
    };

    if (loading) {
        return <div className="loading-screen"><p>Loading event...</p></div>;
    }

    if (!events) {
        return <div>No events found.</div>;
    }

    return (
        <div className='registration-page'>
            {isLoading && (
                <div className="loading-overlay">
                <div className="loading-spinner">Loading...</div>
                </div>
            )}
            <div className="registration-container">
                <h2>{events.title}</h2>
                <h2>
                    {new Date(events.date).toLocaleDateString('en-GB')} (
                    {new Date(`1970-01-01T${events.startTime}`).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })} -
                    {new Date(`1970-01-01T${events.endTime}`).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true })}
                    )
                </h2>
                <div className="progress-indicator">
                    {events.registrationMethod === 'offUs' && (
                        <>
                            <div className='progress-div'>
                                <div className="step active">1</div>
                                <p>Registration</p>
                            </div>
                        </>
                    )}
                    {events.registrationMethod === 'onUs' && ( 
                        <>
                            <div className='progress-div'>
                                <div className={`step ${currentPage === 0 ? 'active' : ''}`}>1</div>
                                <p>Personal Information</p>
                            </div>
                            {events.paymentMethod === 'onUs' && (
                                <>
                                <div className='progress-div'>
                                    <div className={`step ${currentPage === 1 ? 'active' : ''}`}>2</div>
                                    <p>Payment</p>
                                </div>
                                </>
                            )}
                            <div className='progress-div'>
                                <div className={`step ${currentPage === 2 ? 'active' : ''}`}>{events.paymentMethod === 'onUs' ? 3 : 2}</div>
                                <p>Submit</p>
                            </div>
                        </>
                    )}
                </div>

                <form onSubmit={handleSubmit}>
                    {events.registrationMethod === 'offUs' && (
                        <div>
                            <label>
                                Link to Registration: <a href={events.registrationLink}>{events.registrationLink}</a>
                            </label>
                            <br/>
                            <div style={{display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '30px'}}>
                                <button type="submit" className='next-button' onClick={handleClose}>Close</button>
                            </div>
                        </div>
                    )}
                    {currentPage === 0 && events.registrationMethod !== 'offUs' && (
                        <div>
                            <label className='register-events-input'>
                                <span style={{width: '10%'}}>Name:</span>
                                <input type="text" className='events-input' name="name" value={formData.name} onChange={handleChange} required />
                                {errors.name && <p className="error-text">{errors.name}</p>}
                            </label>
                            <label className='register-events-input'>
                                <span style={{width: '10%'}}>Mailing Address:</span>
                                <input type="text" className='events-input' name="address" value={formData.address} onChange={handleChange} required />
                                {errors.address && <p className="error-text">{errors.address}</p>}
                            </label>
                            <label className='register-events-input'>
                                <span style={{width: '10%'}}>Email:</span>
                                <input type="email" className='events-input' name="email" value={formData.email} onChange={handleChange} required />
                                {errors.email && <p className="error-text">{errors.email}</p>}
                            </label>
                            <label className='register-events-input'>
                                <span style={{width: '10%'}}>Phone Number:</span>
                                <input type="text" className='events-input' name="phoneNumber" value={formData.phoneNumber} onChange={handleChange} required />
                                {errors.phoneNumber && <p className="error-text">{errors.phoneNumber}</p>}
                            </label>
                            <label className='register-events-input'>
                                <span style={{width: '10%'}}>IGM Membership:</span>
                                <div>
                                    <label>
                                        <input
                                            type="radio"
                                            name="igmMembership"
                                            value="yes"
                                            checked={formData.igmMembership === 'yes'}
                                            onChange={handleChange}
                                            required
                                        />
                                        Yes
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="igmMembership"
                                            value="no"
                                            checked={formData.igmMembership === 'no'}
                                            onChange={handleChange}
                                            required
                                        />
                                        No
                                    </label>
                                </div>
                                {errors.igmMembership && <p className="error-text">{errors.igmMembership}</p>}
                            </label>
                            {formData.igmMembership === 'yes' && (
                                <label className='register-events-input'>
                                    <span style={{ width: '10%' }}>ID Number:</span>
                                    <input
                                        type="text"
                                        className='events-input'
                                        name="idNumber"
                                        value={formData.idNumber}
                                        onChange={handleChange}
                                        required={formData.igmMembership === 'yes'}
                                    />
                                    {errors.idNumber && <p className="error-text">{errors.idNumber}</p>}
                                </label>
                            )}
                            <label className='register-events-input'>
                                <span style={{ width: '10%' }}>Payment From:</span>
                                <div>
                                    <label>
                                        <input
                                            type="radio"
                                            name="paymentMethod"
                                            value="HRDCorp"
                                            checked={formData.paymentMethod === 'HRDCorp'}
                                            onChange={handleChange}
                                            required
                                        />
                                        HRDCorp
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="paymentMethod"
                                            value="Personal"
                                            checked={formData.paymentMethod === 'Personal'}
                                            onChange={handleChange}
                                            required
                                        />
                                        Personal
                                    </label>
                                </div>
                                {errors.paymentMethod && <p className="error-text">{errors.paymentMethod}</p>}
                            </label>
                            <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                                <button type="button" className='next-button' onClick={nextPage}>Next</button>
                            </div>
                        </div>
                    )}

                    {currentPage === 1 && formData.paymentMethod === 'HRDCorp' && events.registrationMethod !== 'offUs' && (
                        <div>
                            <label className='register-events-input'>
                                <span style={{width: '10%'}}>Company Address:</span>
                                <input type="text" className='events-input' name="companyAddress" value={formData.companyAddress} onChange={handleChange} required />
                                {errors.companyAddress && <p className="error-text">{errors.companyAddress}</p>}
                            </label>
                            <label className='register-events-input'>
                                <span style={{width: '10%'}}>Contact Person (PIC):</span>
                                <input type="text" className='events-input' name="picName" value={formData.picName} onChange={handleChange} required />
                                {errors.picName && <p className="error-text">{errors.picName}</p>}
                            </label>
                            <label className='register-events-input'>
                                <span style={{width: '10%'}}>PIC Email:</span>
                                <input type="text" className='events-input' name="picEmail" value={formData.picEmail} onChange={handleChange} required />
                                {errors.picEmail && <p className="error-text">{errors.picEmail}</p>}
                            </label>
                            <label className='register-events-input'>
                                <span style={{width: '10%'}}>PIC Phone No:</span>
                                <input type="text" className='events-input' name="picPhoneNum" value={formData.picPhoneNum} onChange={handleChange} required />
                                {errors.picPhoneNum && <p className="error-text">{errors.picPhoneNum}</p>}
                            </label>
                            <div style={{display: 'flex', justifyContent: 'flex-end', gap: '10px'}}>
                                <button type="button" className='next-button' onClick={prevPage}>Back</button>
                                <button type="button" className='next-button' onClick={nextPage}>Next</button>
                            </div>
                        </div>
                    )}

                    {currentPage === 1 && formData.paymentMethod === 'Personal' && events.registrationMethod !== 'offUs' && (
                        <div>
                            <div style={{display: 'flex', justifyContent: 'space-evenly'}}>
                                <img src={events.duitnowURL} width='30%' height='30%'/>
                                <div style={{textAlign: 'left', display: 'flex', flexDirection: 'column', gap: '15px'}}>
                                    {events.prices.map((price, index) => (
                                       <strong key={index}>
                                            {price.type} Price: RM {price.amount}
                                       </strong>
                                    ))}
                                </div>
                            </div>
                            <label className='register-events-input'>
                                <span style={{width: '10%'}}>Transfer Ref No.:</span>
                                <input type="text" className='events-input' name="transferRefNo" value={formData.transferRefNo} onChange={handleChange} required />
                                {errors.transferRefNo && <p className="error-text">{errors.transferRefNo}</p>}
                            </label>
      
                            {/* File Upload Input */}
                            <label className='register-events-input'>
                                <span style={{width: '10%'}}>Proof of Payment:</span>
                                <input 
                                    type="file"
                                    className='events-input'
                                    name="paymentProof"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        setFormData({ 
                                            ...formData, 
                                            paymentProof: file, 
                                            paymentProofName: file ? file.name : ''
                                        });
                                    }} 
                                    required 
                                />
                                {formData.paymentProofName && (
                                    <span className="filename-display">{formData.paymentProofName}</span>
                                )}
                                {errors.paymentProof && <p className="error-text">{errors.paymentProof}</p>}
                            </label>
                            <div style={{display: 'flex', justifyContent: 'flex-end', gap: '10px'}}>
                                <button type="button" className='next-button' onClick={prevPage}>Back</button>
                                <button type="button" className='next-button' onClick={nextPage}>Next</button>
                            </div>
                        </div>
                    )}

                    {currentPage === 2 && events.registrationMethod !== 'offUs' && (
                        <div>
                            {events.paymentMethod === 'offUs' && (
                                <label>
                                    Link to Payment: <a href={events.link}>{events.link}</a>
                                </label>
                            )}
                            <br/>
                            <label>
                                <input
                                    type="checkbox"
                                    name="consent"
                                    checked={formData.consent}
                                    onChange={(e) => setFormData({ ...formData, consent: e.target.checked })}
                                    required
                                />
                                I consent to the processing of my personal data in accordance with the PDPA Act in Malaysia.
                            </label>
                            {errors.consent && <p className="error-text">{errors.consent}</p>}
                            <div style={{display: 'flex', justifyContent: 'center', gap: '10px', marginTop: '30px'}}>
                                <button type="button" className='next-button' onClick={prevPage}>Back</button>
                                <button type="submit" className='next-button' onClick={handleSubmit}>Submit</button>
                            </div>
                        </div>
                    )}
                </form>
            </div>

            <ToastContainer/>
        </div>
    );
}

export default Registration;